import Model from './Model'

export default class PricePlan extends Model {
    // Set the resource route of the model
    resource() {
        return 'price-plans'
    }
}
